import React, { useEffect } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { sagaActions } from '../../../sagas/sagaActions';
import { getAuthReducer } from '../../../redux/reducers/reducerSlices/AuthReducer';
import { getUserSelector } from '../../../redux/reducers/reducerSlices/UserReducer';

export default function MicrosoftCallback() {
  const user = useSelector(getAuthReducer);
  const userPermission = useSelector(getUserSelector);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  // 1️⃣ After token is stored → fetch user type
  useEffect(() => {
    if (user?.sessionToken) {
      dispatch({
        type: sagaActions.GET_USER_TYPE,
        payload: {
          cu_id: user?.auth?.username
        }
      });
    }
  }, [user, dispatch]);

  // 2️⃣ Once permissions loaded → go home
  useEffect(() => {
    if (userPermission?.userType) {
      navigate("/");
    }
  }, [userPermission, navigate]);

  // 3️⃣ Exchange authorization code
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get("code");

    if (!code) return;

    dispatch({
      type: sagaActions.MICROSOFT_SSO_REQUEST,
      payload: { code }
    });
  }, [location.search, dispatch]);

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <img
          src="https://freightsmit-fileupload-bucket-dkg-prod.s3.us-east-2.amazonaws.com/tsc_logo.png"
          alt="Microsoft"
          style={styles.logo}
        />

        <div style={styles.loader} />

        <h2 style={styles.title}>Signing you in</h2>
        <p style={styles.subtitle}>
          Verifying your TSC account and setting things up…
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #f5f7fa, #e4ecf7)"
  },
  card: {
    background: "#ffffff",
    padding: "40px 48px",
    borderRadius: "12px",
    textAlign: "center",
    boxShadow: "0 20px 40px rgba(0,0,0,0.08)",
    maxWidth: "420px",
    width: "100%"
  },
  logo: {
    width: "48px",
    marginBottom: "24px"
  },
  loader: {
    width: "42px",
    height: "42px",
    border: "3px solid #e5e7eb",
    borderTop: "3px solid #2563eb",
    borderRadius: "50%",
    margin: "0 auto 24px",
    animation: "spin 1s linear infinite"
  },
  title: {
    margin: 0,
    fontSize: "20px",
    fontWeight: 600,
    color: "#111827"
  },
  subtitle: {
    marginTop: "8px",
    fontSize: "14px",
    color: "#6b7280"
  }
};
